const actions = {
  FETCH_USERFORM: 'onlineForms/FETCH_USERFORM',
}

export default actions
